module.exports = __webpack_public_path__ + "static/media/OperationalPerformanceAr.88621e42.pdf";